let ImageSize = /*#__PURE__*/function (ImageSize) {
  ImageSize["Original"] = "";
  ImageSize["Inline"] = "16x16";
  ImageSize["Icon"] = "32x32";
  ImageSize["Thumb"] = "50x50";
  ImageSize["SmallLogo"] = "100x100";
  ImageSize["Logo"] = "160x160";
  ImageSize["ProductThumb"] = "240x240";
  ImageSize["ProductImage"] = "480x480";
  ImageSize["BannerImage"] = "600x600";
  ImageSize["WallPaper1024"] = "1024x1024";
  ImageSize["WallPaper2048"] = "2048x2048";
  return ImageSize;
}({});
let RteModal = /*#__PURE__*/function (RteModal) {
  RteModal[RteModal["InsertImage"] = 0] = "InsertImage";
  RteModal[RteModal["InsertVideo"] = 1] = "InsertVideo";
  RteModal[RteModal["UpdateLink"] = 2] = "UpdateLink";
  RteModal[RteModal["EditImage"] = 3] = "EditImage";
  return RteModal;
}({});
let RtePopover = /*#__PURE__*/function (RtePopover) {
  RtePopover[RtePopover["Formatting"] = 0] = "Formatting";
  RtePopover[RtePopover["Alignment"] = 1] = "Alignment";
  RtePopover[RtePopover["Color"] = 2] = "Color";
  RtePopover[RtePopover["Table"] = 3] = "Table";
  return RtePopover;
}({});
let LinkSelectionType = /*#__PURE__*/function (LinkSelectionType) {
  LinkSelectionType[LinkSelectionType["Insert"] = 0] = "Insert";
  LinkSelectionType[LinkSelectionType["Edit"] = 1] = "Edit";
  LinkSelectionType[LinkSelectionType["Empty"] = 2] = "Empty";
  return LinkSelectionType;
}({});
let RteCommand = /*#__PURE__*/function (RteCommand) {
  RteCommand["Bold"] = "bold";
  RteCommand["Italic"] = "italic";
  RteCommand["Underline"] = "underline";
  RteCommand["OrderedList"] = "insertOrderedList";
  RteCommand["UnorderedList"] = "insertUnorderedList";
  RteCommand["SelectNode"] = "selectNode";
  RteCommand["TextColor"] = "forecolor";
  RteCommand["BackgroundColor"] = "backcolor";
  return RteCommand;
}({});
let TypographyCommand = /*#__PURE__*/function (TypographyCommand) {
  TypographyCommand["Bold"] = "bold";
  TypographyCommand["Italic"] = "italic";
  TypographyCommand["Underline"] = "underline";
  TypographyCommand["OrderedList"] = "insertOrderedList";
  TypographyCommand["UnorderedList"] = "insertUnorderedList";
  return TypographyCommand;
}({});
let LinkTarget = /*#__PURE__*/function (LinkTarget) {
  LinkTarget["External"] = "_blank";
  LinkTarget["Internal"] = "";
  return LinkTarget;
}({});
let Alignment = /*#__PURE__*/function (Alignment) {
  Alignment["Left"] = "left";
  Alignment["Center"] = "center";
  Alignment["Right"] = "right";
  return Alignment;
}({});
let ToolbarElement = /*#__PURE__*/function (ToolbarElement) {
  ToolbarElement[ToolbarElement["TextFormat"] = 0] = "TextFormat";
  ToolbarElement[ToolbarElement["TextModifierBold"] = 1] = "TextModifierBold";
  ToolbarElement[ToolbarElement["TextModifierItalic"] = 2] = "TextModifierItalic";
  ToolbarElement[ToolbarElement["TextModifierUnderline"] = 3] = "TextModifierUnderline";
  ToolbarElement[ToolbarElement["TextModifierColor"] = 4] = "TextModifierColor";
  ToolbarElement[ToolbarElement["TextAlignment"] = 5] = "TextAlignment";
  ToolbarElement[ToolbarElement["InsertLink"] = 6] = "InsertLink";
  ToolbarElement[ToolbarElement["InsertImage"] = 7] = "InsertImage";
  ToolbarElement[ToolbarElement["InsertVideo"] = 8] = "InsertVideo";
  ToolbarElement[ToolbarElement["InsertTable"] = 9] = "InsertTable";
  ToolbarElement[ToolbarElement["UnorderedList"] = 10] = "UnorderedList";
  ToolbarElement[ToolbarElement["OrderedList"] = 11] = "OrderedList";
  ToolbarElement[ToolbarElement["Outdent"] = 12] = "Outdent";
  ToolbarElement[ToolbarElement["Indent"] = 13] = "Indent";
  ToolbarElement[ToolbarElement["ClearFormatting"] = 14] = "ClearFormatting";
  return ToolbarElement;
}({});
let TypographicElement = /*#__PURE__*/function (TypographicElement) {
  TypographicElement["Paragraph"] = "p";
  TypographicElement["Heading1"] = "h1";
  TypographicElement["Heading2"] = "h2";
  TypographicElement["Heading3"] = "h3";
  TypographicElement["Heading4"] = "h4";
  TypographicElement["Heading5"] = "h5";
  TypographicElement["Heading6"] = "h6";
  TypographicElement["Blockquote"] = "blockquote";
  return TypographicElement;
}({});
const DEFAULT_LINK = {
  href: '',
  target: LinkTarget.Internal,
  title: ''
};

export { Alignment, DEFAULT_LINK, ImageSize, LinkSelectionType, LinkTarget, RteCommand, RteModal, RtePopover, ToolbarElement, TypographicElement, TypographyCommand };
